var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsHkDelivery = function SvgNnIconFlagsHkDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-HK-delivery_svg__Lager_35",
    "data-name": "Lager 35",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-HK-delivery_svg__cls-3{fill:#fff}.nn-icon-flags-HK-delivery_svg__cls-4{fill:#e50000}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22v33.56H.13z",
    style: {
      fill: "#f20000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-HK-delivery_svg__petal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.91c-5.85-2.47-3.26-10.09 2.33-9.7a1.72 1.72 0 0 0-.65 2.7 2.6 2.6 0 0 1-1 3.37 2.13 2.13 0 0 0-.68 3.63",
    className: "nn-icon-flags-HK-delivery_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.91 11.41-.33.51-.12-.59-.59-.16.54-.3v-.61l.45.42.57-.23-.26.56.39.47ZM25.23 16.84a3.17 3.17 0 0 1-1.52-2 3.87 3.87 0 0 1 .52-3.08l-.12-.07a4 4 0 0 0-.51 3.22 3.3 3.3 0 0 0 1.63 2.06Z",
    className: "nn-icon-flags-HK-delivery_svg__cls-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-HK-delivery_svg__petal-2",
    "data-name": "petal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.91c.55-6.32 8.59-6.21 10-.78a1.72 1.72 0 0 0-2.74.21 2.62 2.62 0 0 1-3.53 0 2.13 2.13 0 0 0-3.73.57",
    className: "nn-icon-flags-HK-delivery_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.36 14.91-.59-.16.54-.29v-.62l.45.42.57-.22-.26.55.39.47-.61-.07-.33.52ZM25.3 16.91a3.22 3.22 0 0 1 1.46-2.08 3.8 3.8 0 0 1 3-.51v-.15a4 4 0 0 0-3.16.54 3.35 3.35 0 0 0-1.44 2.2Z",
    className: "nn-icon-flags-HK-delivery_svg__cls-4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-HK-delivery_svg__petal-3",
    "data-name": "petal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.91c6.18-1.43 8.56 6.25 3.82 9.22a1.72 1.72 0 0 0-1-2.54 2.61 2.61 0 0 1-1.14-3.34 2.13 2.13 0 0 0-1.68-3.34",
    className: "nn-icon-flags-HK-delivery_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.72 21.17v-.61l.45.42.57-.23-.25.56.38.47-.64-.07-.33.52-.12-.6-.55-.16ZM25.23 16.98a3.24 3.24 0 0 1 2.42.74 3.85 3.85 0 0 1 1.43 2.74h.15a4 4 0 0 0-1.49-2.84 3.33 3.33 0 0 0-2.51-.78Z",
    className: "nn-icon-flags-HK-delivery_svg__cls-4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-HK-delivery_svg__petal-4",
    "data-name": "petal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.91c3.27 5.44-3.29 10.07-7.59 6.48a1.72 1.72 0 0 0 2.09-1.78 2.64 2.64 0 0 1 2.83-2.12 2.13 2.13 0 0 0 2.67-2.58",
    className: "nn-icon-flags-HK-delivery_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.23 21.55.57-.23-.25.56.39.47-.61-.07-.33.51-.12-.6-.59-.15.53-.3v-.61ZM25.16 16.91a3.2 3.2 0 0 1 0 2.53A3.85 3.85 0 0 1 23 21.65v.13a4 4 0 0 0 2.24-2.29 3.3 3.3 0 0 0 0-2.65Z",
    className: "nn-icon-flags-HK-delivery_svg__cls-4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-HK-delivery_svg__petal-5",
    "data-name": "petal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.23 16.91c-4.15 4.79-10.59 0-8.5-5.22a1.72 1.72 0 0 0 2.34 1.44 2.62 2.62 0 0 1 2.89 2 2.12 2.12 0 0 0 3.27 1.78",
    className: "nn-icon-flags-HK-delivery_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9 15.51.39.47-.61-.07-.33.52-.12-.6-.59-.16.53-.29v-.61l.45.41.57-.22ZM25.17 16.91a3.16 3.16 0 0 1-2.39.82 3.87 3.87 0 0 1-2.77-1.37l-.11.1a4 4 0 0 0 2.87 1.42 3.34 3.34 0 0 0 2.51-.87Z",
    className: "nn-icon-flags-HK-delivery_svg__cls-4"
  }))));
};
export default SvgNnIconFlagsHkDelivery;